/* eslint-disable @typescript-eslint/ban-ts-comment */
import React, { useState, useEffect, useMemo } from "react";
import ProductCard from "../ProductCard.js";
import { ModalPopup } from "wbm-generic-components";
//@ts-ignore - material ui imports are unable to use .js file extensions
import ErrorOutlineIcon from "@material-ui/icons/ErrorOutline";
import { dataTransform } from "./transform.js";
import { isYesOrTrue } from "../../utilities/utilities.js";
import ConfigProps from "../../constants/configProps.js";
import { SupercedeDisplayCondition } from "../../constants/enums.js";
import { ISupercedeProduct } from "@wbmason/cart-service/interfaces/supercedeProduct.js";
import { IIndicatorIcon } from "../../interfaces/IIndicatorIcon.js";
import { IItemAvailability } from "../../interfaces/IItemAvailability.js";
import { IProductInfo } from "../../interfaces/IProductInfo.js";
import { IProductImage } from "../../interfaces/IProductImage.js";

export interface ISupersedeHardProps {
  configProps: Record<string, string>;
  supersedeProduct: ISupercedeProduct[];
  supersedeClick: (
    supersedeProduct: ISupercedeProduct[],
    productInfo: IProductInfo
  ) => void;
  onClose?: () => void;
  setShow?: boolean;
  isLoading?: boolean;
  productImages: IProductImage[];
  sourceProductIndicators: IIndicatorIcon[];
  relatedProductIndicators: IIndicatorIcon[];
  availability: IItemAvailability[];
  productImagesLoaded?: boolean;
  hostUrl: string;
}

export const SupersedeHardModal: React.FC<ISupersedeHardProps> = (
  props: ISupersedeHardProps
) => {
  const [showProductPrice, setShowProductPrice] = useState<boolean>(true);

  const displayCloseButtonOnSupersedesPopup = isYesOrTrue(
    props.configProps[ConfigProps.DisplayCloseButtonOnSupercedesPopup]
  );
  const relatedProduct = props.supersedeProduct[0].relatedProducts[0];
  const customMessage = props.supersedeProduct[0].customMessage;
  const sourceProduct = props.supersedeProduct[0].sourceProduct;

  const buttonClick = () => {
    props.supersedeClick(
      [{ ...props.supersedeProduct[0] }],
      dataTransform(relatedProduct, props.productImages)
    );
  };

  useEffect(() => {
    if (
      props.supersedeProduct[0].displayLowerOriginalPrice ===
        SupercedeDisplayCondition.Never &&
      sourceProduct.sellPrice < relatedProduct.sellPrice
    ) {
      setShowProductPrice(false);
    }
  }, [props.supersedeProduct, sourceProduct, relatedProduct]);

  const productInfo: IProductInfo[] = useMemo(() => {
    return [
      dataTransform(sourceProduct, props.productImages),
      dataTransform(relatedProduct, props.productImages),
    ];
  }, [sourceProduct, relatedProduct, props.productImages]);

  const [sourceProductInfo, relatedProductInfo] = productInfo;

  return (
    <ModalPopup
      header="ITEM SWAP"
      boxShadow
      closeIcon={displayCloseButtonOnSupersedesPopup}
      setShow={props.setShow}
      isLoading={props.isLoading}
      disableBackdropClick
      className={`supercede-hard-modal ${
        props.isLoading ? "content-loading" : ""
      }`}
      actionItem={buttonClick}
      actionItemText="Continue"
      onClose={props.onClose}
      actionItems
      showCancelButton={displayCloseButtonOnSupersedesPopup}
      customZIndex={1500}
    >
      <div className="supercede-text">
        Based on your account settings, the item you chose needs to be swapped.
      </div>
      <div className="supercede-warning">
        <ErrorOutlineIcon />
        <div className="supercede-warning-text">
          By clicking continue, the swap item will replace your selected item in
          your cart.
        </div>
      </div>
      <div className="row no-gutters">
        <div className="col-12 col-md-6 spacing">
          <div className="original-supercede">
            <div className="supercede-label-text">
              You have selected this item
            </div>
            <ProductCard
              configProps={props.configProps}
              productInfo={sourceProductInfo}
              itemIndicators={props.sourceProductIndicators}
              maxLength={4}
              displayAddToCart={false}
              productImagesLoaded={props.productImagesLoaded}
              preventListPrice={true}
              hideRelevanceScore={true}
              hideProductPrice={!showProductPrice}
              hostUrl={props.hostUrl}
            />
          </div>
        </div>
        <div className="col-12 col-md-6 spacing">
          <div className="supercede-label-text">
            {customMessage ? customMessage : "Item that will be swapped"}
          </div>
          <div className="selected-supercede">
            <ProductCard
              configProps={props.configProps}
              productInfo={relatedProductInfo}
              itemIndicators={props.relatedProductIndicators}
              itemAvailability={props.availability[0]}
              maxLength={4}
              displayAddToCart={false}
              productImagesLoaded={props.productImagesLoaded}
              preventListPrice={true}
              hideRelevanceScore={true}
              swapSavings={sourceProduct.sellPrice - relatedProduct.sellPrice}
              hostUrl={props.hostUrl}
            />
          </div>
        </div>
      </div>
    </ModalPopup>
  );
};

export default SupersedeHardModal;
